export default __webpack_public_path__ + "static/media/rae-logo.00955335.png";